import { Stat } from "../../components/ui";
import { statusTone } from "./status";

/** The eight statuses as tiles, each a filter. A tile's count is how many
 * sites are in that status under the other filters (the server's
 * `count_by_status`), so an unselected tile never reads a misleading zero, and
 * ticking several tiles shows the sites in any of them. */
export default function StatusStrip({
  statuses,
  counts,
  selected,
  onToggle,
}: {
  statuses: readonly { value: string; label: string }[];
  counts: Record<string, number>;
  selected: readonly string[];
  onToggle: (status: string) => void;
}) {
  return (
    <div className="stat-strip site-status-strip" role="group" aria-label="Filter by status">
      {statuses.map((status) => (
        <Stat
          key={status.value}
          label={status.label}
          value={counts[status.value] ?? 0}
          tone={statusTone(status.value)}
          pressed={selected.includes(status.value)}
          onClick={() => onToggle(status.value)}
        />
      ))}
    </div>
  );
}
